import request from 'api/request';
import {MAX_NOTE_LEN} from 'helpers/constants';
import {handleError, formatter, formValidation} from 'helpers';

import {asyncLoad} from '.';
import * as alerts from './alertActions';
import reloadInventory from './inventoryActions';
import {inventoryLocationActionTypes as actionTypes} from './actionTypes';

export const loadInventoryLocationsAsync = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'inventory locations',
    url: '/inventorylocations',
  });

export const loadDefaultInventoryLocationAsync = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'default inventory location',
    url: '/inventorylocations/default',
  });

const getInventoryLocations = filter => dispatch => {
  dispatch({type: actionTypes.INVENTORY_LOCATIONS_LOADING});

  const url = `/InventoryLocations`; // client side pagination/sorting/etc.

  return request({url})
    .then(data => {
      const results =
        data && data.data && data.data.results ? data.data.results : [];
      const totalRows =
        data && data.data && data.data.totalRows ? data.data.totalRows : 0;

      dispatch({
        type: actionTypes.GET_INVENTORY_LOCATIONS_SUCCESS,
        locations: results.map(location => ({
          ...location,
          displayNotes: formatter.formatDescription(
            location.notes,
            MAX_NOTE_LEN,
          ),
          fullAddress: formatter.formatAddress(location),
        })),
        totalRows,
        searchString: filter,
      });
      dispatch({type: actionTypes.INVENTORY_LOCATIONS_LOADING_COMPLETE});
    })
    .catch(error => {
      handleError('Unable to load Inventory Locations', error, dispatch);
      dispatch({type: actionTypes.INVENTORY_LOCATIONS_LOADING_COMPLETE});
    });
};

export const getInventoryLocationsList = (searchOptions = {}) => dispatch => {
  const {searchString, filterOption} = searchOptions;
  return dispatch(getInventoryLocations(searchString, filterOption));
};

export const getDefaultInventoryLocation = () => dispatch => {
  const url = `/inventorylocations/default`;

  return request({url})
    .then(data => {
      dispatch({
        type: actionTypes.GET_DEFAULT_INVENTORY_LOCATION_SUCCESS,
        defaultInventoryLocation: data.data,
      });
    })
    .catch(error => {
      handleError('Unable to load Default Inventory Location', error, dispatch);
    });
};

// Select Location
export const updateSelectBatchIndividual = location => dispatch =>
  dispatch({
    type: actionTypes.INVENTORY_LOCATION_BATCH_SELECT_INDIVIDUAL_UPDATED,
    location,
  });

// Select All Locations
export const updateSelectBatchAll = (
  isChecked,
  startIdx = 0,
  endIdx = null,
) => dispatch =>
  dispatch({
    type: actionTypes.INVENTORY_LOCATION_BATCH_SELECT_ALL_UPDATED,
    isChecked,
    startIdx,
    endIdx,
  });

// Add or Edit Location
export const addEditLocation = (location, update) => dispatch => {
  const url = `/inventorylocations${
    update ? `/${location.inventoryLocationId.value}` : ''
  }`;
  const formObject = formValidation.setupFormBody(location, update);

  if (formObject.hasError) {
    dispatch(alerts.error(formObject.errorMessage));
    return null;
  }

  return request({
    url,
    method: update ? 'PATCH' : 'POST',
    body: formObject.body,
  })
    .then(response => {
      if (response.status === 400) {
        if (response.data.code === 50345) {
          return true;
        } else {
          throw new Error(response.data.message);
        }
      }

      dispatch(getInventoryLocationsList());

      return false;
    })
    .catch(error => {
      handleError(
        `Unable to ${update ? 'update' : 'add'} Inventory Location`,
        error,
        dispatch,
      );
      return null;
    });
};

// Delete Location
export const deleteLocations = (locations, callback) => (
  dispatch,
  getState,
) => {
  dispatch({type: actionTypes.INVENTORY_LOCATIONS_LOADING});

  return request({
    url: `/inventorylocations`,
    method: 'DELETE',
    body: locations.map(x => x.inventoryLocationId),
  })
    .then(() => {
      dispatch(alerts.success('Successfully deleted'));
      dispatch(getInventoryLocationsList());
      reloadInventory(dispatch, getState, {useDefaultLocation: true});

      if (callback && typeof callback === 'function') {
        callback();
      }

      return true;
    })
    .catch(error => {
      handleError('Unable to delete Inventory Locations', error, dispatch);
      return false;
    });
};

export const exportLocationsCSV = () => dispatch => {
  return request({
    url: '/CSV/InventoryLocations',
    headers: {contentType: 'text/csv'},
  })
    .then(result => {
      if (result.status === 200) {
        dispatch(alerts.success(result.data.message));
        return true;
      }
      return false;
    })
    .catch(error => handleError('Error exporting to CSV', error, dispatch));
};



// WEBPACK FOOTER //
// ./src/actions/inventoryLocationActions.js